"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetNoChildren = exports.unsetLoadingState = exports.unsetData = exports.unsetActiveChild = exports.setToDate = exports.setNoChildren = exports.setLoadingState = exports.setFromDate = exports.setData = exports.setActiveChild = exports.resetState = exports.initialState = exports.getData = exports["default"] = exports.changeActiveChild = void 0;
var _reduxActions = require("redux-actions");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _moment = _interopRequireDefault(require("moment"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _cccisdApollo = require("cccisd-apollo");
var _templateObject, _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } // import _findKey from 'lodash/findKey';
var AppDefs = window.cccisd.appDefs;

// Initial state
var initialState = exports.initialState = {
  loading: true,
  data: [],
  activeChild: {},
  noChildren: false
};

// Actions
var SET_LOADING_STATE = 'groupProgressAdapter/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'groupProgressAdapter/UNSET_LOADING_STATE';
var SET_DATA = 'groupProgressAdapter/SET_DATA';
var UNSET_DATA = 'groupProgressAdapter/UNSET_DATA';
var SET_ACTIVE_CHILD = 'groupProgressAdapter/SET_ACTIVE_CHILD';
var UNSET_ACTIVE_CHILD = 'groupProgressAdapter/UNSET_ACTIVE_CHILD';
var SET_TO_DATE = 'groupProgressAdapter/SET_TO_DATE';
var SET_FROM_DATE = 'groupProgressAdapter/SET_FROM_DATE';
var RESET_STATE = 'groupProgressAdapter/RESET_STATE';
var SET_NO_CHILDREN = 'groupOutcomesAdapter/SET_NO_CHILDREN';
var UNSET_NO_CHILDREN = 'groupOutcomesAdapter/UNSET_NO_CHILDREN';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setData = exports.setData = (0, _reduxActions.createAction)(SET_DATA);
var unsetData = exports.unsetData = (0, _reduxActions.createAction)(UNSET_DATA);
var setActiveChild = exports.setActiveChild = (0, _reduxActions.createAction)(SET_ACTIVE_CHILD);
var unsetActiveChild = exports.unsetActiveChild = (0, _reduxActions.createAction)(UNSET_ACTIVE_CHILD);
var setToDate = exports.setToDate = (0, _reduxActions.createAction)(SET_TO_DATE);
var setFromDate = exports.setFromDate = (0, _reduxActions.createAction)(SET_FROM_DATE);
var resetState = exports.resetState = (0, _reduxActions.createAction)(RESET_STATE);
var setNoChildren = exports.setNoChildren = (0, _reduxActions.createAction)(SET_NO_CHILDREN);
var unsetNoChildren = exports.unsetNoChildren = (0, _reduxActions.createAction)(UNSET_NO_CHILDREN);
var _runQuery = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query, variables) {
    var formattedQuery, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formattedQuery = (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context.next = 3;
          return _cccisdApollo.client.query({
            query: formattedQuery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 3:
          result = _context.sent;
          return _context.abrupt("return", result.data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function _runQuery(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _composeDisplaySettings = function _composeDisplaySettings(data, displaySettings, reportHandle) {
  var formattedData = [];
  data.forEach(function (session) {
    var newSession = {};
    if ('sessionReportLabels' in displaySettings) {
      var displaySession = (0, _find2["default"])(displaySettings.sessionReportLabels, function (ds) {
        return ds.handle === session.handle;
      });
      if (displaySession) {
        var report = (0, _find2["default"])(displaySession.reports, function (settings) {
          return settings.handle === reportHandle;
        });
        newSession = Object.assign(session, (0, _omit2["default"])(report, 'handle'));
      }
    }
    formattedData.push(newSession);
  });
  return formattedData;
};
var _determineInitialChild = function _determineInitialChild(policy, childData) {
  return (0, _first2["default"])(childData);
};
var sessionBuildOut = function sessionBuildOut(_ref2) {
  var child = _ref2.child,
    groupMetrics = _ref2.groupMetrics;
  var individualSessions = (0, _filter2["default"])(AppDefs.sessions.fixedSettings.sessions, function (s) {
    return s.type === 'session';
  });
  var sessions = [];
  individualSessions.forEach(function (is) {
    var newIndividualSession = (0, _omit2["default"])(is, ['activities', 'sessionMetricsPrefix', 'sessionDevTagPrefix']);
    var matchingIndividualSession = (0, _find2["default"])(groupMetrics, function (im) {
      return im.responseSet === is.responseSet;
    });
    var matchingChildIndividualSession = (0, _find2["default"])(child.IndividualMetrics, function (cim) {
      return cim.responseSet === is.responseSet;
    });
    if (matchingIndividualSession) {
      newIndividualSession = Object.assign(newIndividualSession, (0, _omit2["default"])(matchingIndividualSession.devTags, ['__typename']));
    }
    if (matchingChildIndividualSession) {
      newIndividualSession = Object.assign(newIndividualSession, matchingChildIndividualSession.devTagLists);
    }
    sessions.push(newIndividualSession);
  });
  return sessions;
};
var _buildChildSessions = function _buildChildSessions(_ref3) {
  var child = _ref3.child,
    sessions = _ref3.sessions,
    displaySettings = _ref3.displaySettings,
    reportHandle = _ref3.reportHandle;
  var formattedSessions = _composeDisplaySettings(sessions, displaySettings, reportHandle);
  return Object.assign({}, child, {
    sessions: formattedSessions
  });
};
var changeActiveChild = exports.changeActiveChild = function changeActiveChild(_ref4) {
  var pawn = _ref4.pawn,
    dataPath = _ref4.dataPath,
    displaySettings = _ref4.displaySettings,
    reportHandle = _ref4.reportHandle,
    acrossChildrenSettings = _ref4.acrossChildrenSettings;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var data, base, childData, activeChild, sessions, heldSessions, sessionDates, sessionDateTimestamps, sortedDates, from, date, to;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(setLoadingState());
            data = getState().impact.groupProgressAdapter.data;
            base = (0, _get2["default"])(data, dataPath);
            childData = (0, _get2["default"])(base, acrossChildrenSettings.childrenPath);
            activeChild = (0, _find2["default"])(childData, function (cd) {
              return cd.pawn.pawnId === pawn.pawn.pawnId;
            });
            sessions = sessionBuildOut({
              child: activeChild,
              groupMetrics: base.GroupMetrics
            });
            activeChild = _buildChildSessions({
              child: activeChild,
              sessions: sessions,
              displaySettings: displaySettings,
              reportHandle: reportHandle
            });

            // ----DATES----
            heldSessions = (0, _filter2["default"])(sessions, function (fs) {
              return fs.held === '1' || fs.held === true;
            }); // get all held sessions dates
            sessionDates = (0, _map2["default"])(heldSessions, function (item) {
              return (0, _pick2["default"])(item, ['date']);
            }); // convert dates to timestamps and sort 'em
            sessionDateTimestamps = [];
            (0, _forEach2["default"])(sessionDates, function (value) {
              return sessionDateTimestamps.push((0, _moment["default"])(value.date, 'MM/DD/YYYY').format('X'));
            });
            sortedDates = sessionDateTimestamps.sort();
            from = null;
            if ((0, _first2["default"])(sortedDates)) {
              date = new Date(parseInt((0, _first2["default"])(sortedDates), 10) * 1000);
              from = (0, _moment["default"])(date);
            }
            to = (0, _isUndefined2["default"])((0, _last2["default"])(sortedDates)) ? null : (0, _moment["default"])(new Date(parseInt((0, _last2["default"])(sortedDates), 10) * 1000));
            dispatch(setFromDate(from));
            dispatch(setToDate(to));
            dispatch(setActiveChild(activeChild));
            dispatch(unsetLoadingState());
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var getData = exports.getData = function getData(_ref6) {
  var query = _ref6.query,
    variables = _ref6.variables,
    dataPath = _ref6.dataPath,
    acrossChildrenSettings = _ref6.acrossChildrenSettings,
    _ref6$policy = _ref6.policy,
    policy = _ref6$policy === void 0 ? 'last_incomplete' : _ref6$policy,
    displaySettings = _ref6.displaySettings,
    reportHandle = _ref6.reportHandle;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var response, base, childData, activeChild, sessions, heldSessions, sessionDates, sessionDateTimestamps, sortedDates, from, date, to;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(setLoadingState());
            _context3.next = 3;
            return _runQuery(query, variables);
          case 3:
            response = _context3.sent;
            dispatch(setData(response));
            base = (0, _get2["default"])(response, dataPath);
            childData = (0, _get2["default"])(base, acrossChildrenSettings.childrenPath);
            if (!(0, _isEmpty2["default"])(childData)) {
              activeChild = _determineInitialChild(policy, childData);
              sessions = sessionBuildOut({
                child: activeChild,
                groupMetrics: base.GroupMetrics
              });
              activeChild = _buildChildSessions({
                child: activeChild,
                sessions: sessions,
                displaySettings: displaySettings,
                reportHandle: reportHandle
              });

              // ----DATES----
              heldSessions = (0, _filter2["default"])(sessions, function (fs) {
                return fs.held === '1' || fs.held === true;
              }); // get all held sessions dates
              sessionDates = (0, _map2["default"])(heldSessions, function (item) {
                return (0, _pick2["default"])(item, ['date']);
              }); // convert dates to timestamps and sort 'em
              sessionDateTimestamps = [];
              (0, _forEach2["default"])(sessionDates, function (value) {
                return sessionDateTimestamps.push((0, _moment["default"])(value.date, 'MM/DD/YYYY').format('X'));
              });
              sortedDates = sessionDateTimestamps.sort();
              from = null;
              if ((0, _first2["default"])(sortedDates)) {
                date = new Date(parseInt((0, _first2["default"])(sortedDates), 10) * 1000);
                from = (0, _moment["default"])(date);
              }
              to = (0, _isUndefined2["default"])((0, _last2["default"])(sortedDates)) ? null : (0, _moment["default"])(new Date(parseInt((0, _last2["default"])(sortedDates), 10) * 1000));
              dispatch(setFromDate(from));
              dispatch(setToDate(to));
              dispatch(setActiveChild(activeChild));
            } else {
              dispatch(setNoChildren());
            }
            dispatch(unsetLoadingState());
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload
  });
}), UNSET_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: []
  });
}), SET_ACTIVE_CHILD, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeChild: action.payload
  });
}), UNSET_ACTIVE_CHILD, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeChild: {}
  });
}), SET_TO_DATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    toDate: action.payload
  });
}), SET_FROM_DATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fromDate: action.payload
  });
}), RESET_STATE, function (state, action) {
  return {
    loading: true,
    data: [],
    activeChild: {},
    noChildren: false
  };
}), SET_NO_CHILDREN, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    noChildren: true
  });
}), _defineProperty(_handleActions, UNSET_NO_CHILDREN, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    noChildren: false
  });
})), initialState);